import { __ } from '@wordpress/i18n';
import CardsSelectBox from '../CardsSelectBox';
import { PAYMENT_METHOD_NAME } from '../../contants';
import { PaymentFields } from '../../../../../../../../src/interfaces/WoocommercePaymentBlockSupport';
import { useEffect, useState } from '@wordpress/element';
import MangoPayKit from '../../Types/MangoPayKit';
import apiFetch from '@wordpress/api-fetch';

// @ts-ignore
const { Label, ValidatedTextInput, Button, Spinner } =
    window.wc.blocksComponents;
const AddCard = ( props ) => {
    // @ts-ignore
    const settings: PaymentFields = window.wc.wcSettings.getSetting(
        `${ PAYMENT_METHOD_NAME }_data`
    );
    // @ts-ignore
    const mangoPay: MangoPayKit = window.mangoPay;
    const [ selectedCard, setSelectedCard ] = useState( '' );
    const [ cardnumber, setCardNumber ] = useState( '' );
    const [ cvv, setCvv ] = useState( '' );
    const [ year, setYear ] = useState( '' );
    const [ month, setMonth ] = useState( '' );

    const [ allYear, setAllYear ] = useState( [] );
    const [ allMonth, setAllMonth ] = useState( [] );
    const [ registerLoader, setRegisterLoader ] = useState( false );

    const validateItem = ( item: object ) => {
        // @ts-ignore
        return (
            'BANK_WIRE' !== item.key &&
            'IDEAL' !== item.key &&
            settings?.selected_credit_cards.includes( item.key )
        );
    };

    const updateRegisteredCards = ( cardRegId, cardRegData ) => {
        const data = {
            card_id: cardRegId,
            reg_data: cardRegData,
        };

        apiFetch( {
            data,
            path: '/dokan/v1/mangopay/block/registered/cards',
            method: 'PUT',
        } ).finally( () => {
            setRegisterLoader( false );
            props.refreshCards();
        } );
    };

    const register = (
        cardRegistrationId,
        cardRegistrationURL,
        preRegistrationData,
        accessKey,
        cardData
    ) => {
        mangoPay.cardRegistration.baseURL = settings.mangopay_url;
        mangoPay.cardRegistration.clientId = settings.client_id;

        /** Set data from previous form */
        mangoPay.cardRegistration.init( {
            cardRegistrationURL,
            preregistrationData: preRegistrationData,
            accessKey,
            Id: cardRegistrationId,
        } );

        /** Register */
        mangoPay.cardRegistration.registerCard(
            cardData,
            function ( res ) {
                /** Update front list of cards */
                if ( res.cardRegId && res.cardRegData ) {
                    updateRegisteredCards( res.cardRegId, res.cardRegData );
                } else {
                    setRegisterLoader( false );
                    props.refreshCards();
                }
            },
            function ( res ) {
                /** We have an error */
                console.error( res );

                setRegisterLoader( false );
                props.refreshCards();
            }
        );
    };

    const handleRegister = () => {
        if (
            settings?.userId === undefined ||
            settings?.userId === '' ||
            ! settings?.userId
        ) {
            return;
        }

        /** data for FIRST STEP */
        const data = {
            user_id: settings?.userId,
            card_type: selectedCard,
        };

        let expireMonth = month;
        if ( String( month ).length == 1 ) {
            expireMonth = `0${ String( month ) }`;
        }
        const date = `${ expireMonth }${ String( year ) }`;

        /** data for SECOND STEP */
        const cardData = {
            cardNumber: String( cardnumber ),
            cardExpirationDate: date,
            cardCvx: String( cvv ),
            cardType: selectedCard,
        };

        if (
            ! selectedCard ||
            ! month ||
            ! year ||
            ! cardData.cardNumber ||
            ! cardData.cardCvx
        ) {
            return;
        }

        setRegisterLoader( true );
        apiFetch( {
            data,
            path: '/dokan/v1/mangopay/block/registered/cards',
            method: 'POST',
        } )
            .then( ( res ) => {
                // @ts-ignore
                if ( res?.CardRegistrationId ) {
                    // @ts-ignore
                    const {
                        CardRegistrationId,
                        CardRegistrationURL,
                        PreregistrationData,
                        AccessKey,
                    } = res;

                    register(
                        CardRegistrationId,
                        CardRegistrationURL,
                        PreregistrationData,
                        AccessKey,
                        cardData
                    );
                }
            } )
            .catch( ( err ) => {
                setRegisterLoader( false );
            } );
    };

    useEffect( () => {
        let tempData;

        tempData = Object.keys( settings?.months ?? {} ).map( ( item ) => {
            return {
                value: item,
                label: settings?.months[ item ],
            };
        } );

        if ( tempData[ 0 ] ) {
            setMonth( tempData[ 0 ].value );
        }
        setAllMonth( tempData );

        tempData = Object.keys( settings?.years ?? {} ).map( ( item ) => {
            return {
                value: item,
                label: settings?.years[ item ],
            };
        } );

        if ( tempData[ 0 ] ) {
            setYear( tempData[ 0 ].value );
        }
        setAllYear( tempData );
    }, [] );

    return (
        <div className="dokan-mangopay-add-card-box">
            <Label label={ __( 'Card Type', 'dokan' ) } />
            <CardsSelectBox
                id="choose-card-type"
                cards={ settings?.available_card_types ?? {} }
                selectedCards={ settings?.selected_debit_cards ?? {} }
                validateItem={ validateItem }
                onChange={ ( value ) => setSelectedCard( value ) }
            />

            <ValidatedTextInput
                id="dokan-register-card-number"
                errorId="dokan-register-card-number"
                className=""
                label={ __( 'Card Number', 'dokan' ) }
                type="text"
                value={ cardnumber }
                onChange={ ( newCouponValue ) => {
                    setCardNumber( newCouponValue );
                } }
                focusOnMount={ false }
                validateOnMount={ false }
            />

            <ValidatedTextInput
                id="dokan-register-card-cvv"
                errorId="dokan-register-card-cvv"
                className=""
                label={ __( 'CVV', 'dokan' ) }
                type="text"
                value={ cvv }
                onChange={ ( newCouponValue ) => {
                    setCvv( newCouponValue );
                } }
                focusOnMount={ false }
                validateOnMount={ false }
            />

            <div className="dokan-mangopay-add-card-box-divider"></div>

            <Label label={ __( 'Expiration Date', 'dokan' ) } />
            <div className="dokan-mangopay-expire-select">
                <select
                    className="dokan-mangopay-expire-month"
                    value={ month }
                    onChange={ ( e ) => setMonth( e.target.value ) }
                >
                    { allMonth.map( ( item ) => {
                        return (
                            <option key={ item.value } value={ item.value }>
                                { item.label }
                            </option>
                        );
                    } ) }
                </select>
                <span>/</span>
                <select
                    className="dokan-mangopay-expire-year"
                    value={ year }
                    onChange={ ( e ) => setYear( e.target.value ) }
                >
                    { allYear.map( ( item ) => {
                        return (
                            <option key={ item.value } value={ item.value }>
                                { item.label }
                            </option>
                        );
                    } ) }
                </select>
            </div>

            <div className="dokan-mangopay-add-card-box-divider"></div>

            <div className="dokan-mangopay-add-card-box-button">
                <Button disabled={ registerLoader } onClick={ handleRegister }>
                    { registerLoader ? (
                        <span>{ __( 'Registering…', 'dokan' ) }</span>
                    ) : (
                        <span>{ __( 'Register', 'dokan' ) }</span>
                    ) }
                </Button>
                <Button
                    disabled={ registerLoader }
                    onClick={ () => props.onClose() }
                >
                    { __( 'Cancel', 'dokan' ) }
                </Button>
            </div>
        </div>
    );
};

export default AddCard;
